import { DAILY_MISSION } from '@/config/learning';
import type { Curriculum } from '@/content/curriculum';
import type { LearningSession } from '@/domain/records';
import type { Recommendation } from '@/features/mastery/recommend';
import { localDayKey } from '@/lib/time';

/**
 * Picks the objectives of today's mission: reviews and weak spots first, then
 * current practice and new goals, mixing subjects when possible.
 */
export function pickMissionObjectives(
  recommendations: Recommendation[],
  curriculum: Curriculum,
  max = DAILY_MISSION.objectives,
): string[] {
  const chosen: string[] = [];
  const subjects = new Set<string>();
  const subjectOf = (id: string) => curriculum.objective(id)?.subjectId ?? '';
  // First pass: one objective per subject; second pass: fill remaining slots.
  for (const pass of [0, 1]) {
    for (const rec of recommendations) {
      if (chosen.length >= max) break;
      if (chosen.includes(rec.objectiveId)) continue;
      if (pass === 0 && subjects.has(subjectOf(rec.objectiveId))) continue;
      chosen.push(rec.objectiveId);
      subjects.add(subjectOf(rec.objectiveId));
    }
  }
  return chosen;
}

export function missionDoneOn(sessions: LearningSession[], day: Date): boolean {
  const key = localDayKey(day);
  return sessions.some(
    (s) =>
      s.gameId === 'daily-mission' && s.status === 'completed' && localDayKey(s.startedAt) === key,
  );
}
